import { render, staticRenderFns } from "./EnvironmentIndicator.vue?vue&type=template&id=4df90483&scoped=true"
import script from "./EnvironmentIndicator.vue?vue&type=script&lang=ts"
export * from "./EnvironmentIndicator.vue?vue&type=script&lang=ts"
import style0 from "./EnvironmentIndicator.vue?vue&type=style&index=0&id=4df90483&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df90483",
  null
  
)

export default component.exports